import React, { useState } from "react";
import "./Manual.scss";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Manual = () => {
  const navigate = useNavigate();

  return (
    <div className="manual-outer">
      <div className="manual-inner">
        <div className="manual-inner-icon">
          <IoCloseCircleOutline
            className="manual-inner-icon-inside"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="manual-inner-title">
          <h1 className="manual-inner-title-one">Твій збірник пісень</h1>
          <h2 className="manual-inner-title-two">Як користуватися</h2>
          <p className="manual-text">
            Дуже раді вітати вас у нашому додатку й впевнені, що він стане
            корисним інструментом у вашій творчій діяльності!
          </p>
        </div>
        <div className="section offer-list">
          <h3 className="section-title"> Що можна робити у додатку</h3>
          <ul className="offer-list-ul">
            <li className="offer-list-item">
              Переглядати й вкористовувати будь-які збірники із статусом
              &ldquo;загальний&ldquo;
            </li>
            <li className="offer-list-item">
              Створювати власні збірники пісень
            </li>
            <li className="offer-list-item">
              Додавати учасників із правом редагування збірника
            </li>
            <li className="offer-list-item">
              Завантажувати додаткові файли та медіа для кожної пісні
            </li>
            <li className="offer-list-item">
              Змінювати тональність в один клік
            </li>
            <li className="offer-list-item">
              Розподіляти пісні за категоріями
            </li>
            <li className="offer-list-item">
              Використовувати режим повного екрану
            </li>
            <li className="offer-list-item">Друкувати пісню у PDF</li>
            <li className="offer-list-item">
              Створювати індивідуальні підбірки пісень
            </li>
            <li className="offer-list-item">
              Створювати групи для підбірок і запрошувати учасників
            </li>
            <li className="offer-list-item">Вибирати тарифний план</li>
            {/* <li className="offer-list-item">Завантажити свій збірник у PDF</li> */}
          </ul>
        </div>
        <div className="section">
          <h3 className="section-title">Тарифні плани</h3>
          <p className="manual-text">
            Наразі тарифні плани відключені. Всі функції додатка у вільному
            доступі.
          </p>
          <p className="manual-text">
            У майбутньому у додатку можна буде вибрати один з трьох тарифних
            планів -{" "}
            <span className="highlight">
              Вильній, Індивідуальний, Командний.
            </span>{" "}
            Кожен зареєстрований користувач автоматично доєднується до тарифного
            плану <span className="highlight">Вільний</span>, який є
            безкоштовним. Переглянути умови тарифних планів можна на титульній
            сторінці додатку (натисніть логотип у лівому верхньому куті та
            перейдіть униз сторінки) або у{" "}
            <span className="highlight">Кабінеті</span>. Щоб перейти у Кабінет
            натисніть іконку профілю зврху біля свого імені. Перейти на більш
            розширений тарифний план можна буде у{" "}
            <span className="highlight">Кабінеті</span> у вкладці{" "}
            <span className="highlight">П/Д</span> (Персональні Дані).
            Переходити на розширені тарифні плани зможуть тільки зареєстровані
            користувачі.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">
            Що можна незареєстрованим користувачам
          </h3>
          <p className="manual-text">
            Незареєстровані у додатку користувачі можуть відкривати будь-який
            збірник з переліку, переглядати пісні, користуватися зміною
            тональності та режимом повного екрану, відкривати наявні файли
            медіа.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Як зареєструватись</h3>
          <p className="manual-text">
            Натисність кнопку <span className="highlight">Увійти</span> у
            верхньому правому куті та слідуйте вказівкам.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Збірники</h3>
          <p className="manual-text">
            Відкривати будь-який заганльний збірник можна з титульної сторінки
            додатка.
          </p>
          <p className="manual-text">
            <span className="highlight">Створення збірника.</span>
            Тільки для зареєстрованих користувачів. Зайдіть у свій кабінет у
            вкладку <span className="highlight">Збірники</span> і натисність{" "}
            <span className="highlight">Створити збірник</span>. Введіть назву
            збірника та виберить його статус -{" "}
            <span className="highlight">Приватний</span> чи
            <span className="highlight"> Загальний</span>.
            <span className="highlight"> Загальний</span> означає, що ваш
            збірник буде доступний для переглядку у переліку пісень для всіх
            бажаючих.
            <span className="highlight"> Приватний</span> означає, що ваш
            збірник буде з&apos;являтись тільки у вашому переліку пісень і у
            вашому кабінеті, більше ніхто його не бачитиме.
          </p>
          <p className="manual-text">
            Ви можете додати у свій збірник учасників. Учасником може бути
            будь-який зареєстрований у додатку користувач. Учасник отримує право
            редагувати збірник, тобто додавати, редагувати й видаляти пісні,
            завантажувати файли, але учасних не може змінювати дані про збірник
            - назву, статус, інших учасників. Учасник зможе бачити цей збірник у
            своєму кабінеті, і зможе відкривати його через свій кабінет.
          </p>
          <p className="manual-text">
            Кожен збірник за замовчуванням має категорії, за якими можна
            розподіляти пісні. Категрії створені для християнських пісень. Якщо
            ви не хочете користуватись категоріями, виберіть{" "}
            <span className="highlight">Вимкнути категорії</span> і вони не
            будуть з&apos;являтися у цьому збірнику.
          </p>
          <p className="manual-text">
            <span className="highlight">Редагування та видалення.</span>{" "}
            Редагувати інформацію про збірник або видалити його може тільки
            власник, той хто створив збірник. Для цього перейдіть у кабінет у
            вкладку Збірники, натисніть назву потрібного зібрника та слідуйте
            вказівкам.
          </p>
          <p className="manual-text">
            <span className="highlight">Зміна власника.</span> Функція зміни
            власника у розробці.
          </p>
          <p className="manual-text">
            <span className="highlight">Скачування у PDF.</span> Функція у
            розробці.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Пісні</h3>
          <p className="manual-text">
            <span className="highlight">Додати пісню. </span>
            Щоб додати пісню, натисніть кнопку{" "}
            <span className="highlight">Додати пісню </span> у правому сайдбарі.
            (Якщо сайдбар схований, натисніть стрілочку, щоб його відкрити.) У
            формі для нової пісні введіть назву, виберіть тональність, введіть
            темп і розмір. Виберіть категорії (якщо вони увімкнені для цього
            збірника) - можна вибрати декілька категорій. Введіть текст пісні з
            акордами. Дуже важливо правильно визначити тональність, інакше потім
            зміна тональності може відбуватися не коректно. Натисніть Якщо ви
            хочете зкопіювати текст з будь-якого ресурсу, обов&apos;язково
            вставляйте текст as plain text. Для цього натистніть на праву кнопку
            миші у полі текстового редактора і знайдіть там insert as plain
            text.
            <span className="highlight"> Зберегти</span> внизу сторінки.
          </p>
          <p className="manual-text">
            <span className="highlight">Панель інструментів (тулбар).</span>{" "}
            Зверху назви пісні є тулбар з іконками, за допомогою яких можна
            ховати та показувати акорди, відкривати режим редагування, копіювати
            пісню у свій збірник, вмикати режим повного екрану. Під тулбаром
            знаходяться стрілочки для керування розміром шрифта. Додаток
            запам&apos;ята ваші преференції щодо розміру шрифта та аккордів -
            показувати чи не показувати.
            <span className="highlight"> Сховати акорди</span> у тулбарі зверху.
          </p>
          <p className="manual-text">
            <span className="highlight">Акорди.</span> Після збереження пісні,
            текст у рядках з акордами підсвічується синім кольором. Інші
            терміни, такі як Приспів, Брідж и таке інше, краще виносити в окремі
            рядки. Майте на увазі, що акордів H та Hm не існує. Акорди Сі та Сі
            мінор позначаються буквами B та Bm. За замовучанням акорди пісні
            відображаться на екрані, але їх можна сховати. Для цього натисніть
            на іконку
            <span className="highlight"> Сховати акорди</span> у тулбарі зверху.
          </p>
          <p className="manual-text">
            <span className="highlight"> Замітки.</span>
            Якщо ви хочете додати замітки для музикантів стосовно аранжування
            пісні, винесіть їх в окремий рядок та візьміть у круглі дужки ().
            Тоді замітки будуть виділені зеленим кольором та вони не будуть
            показані не авторизованим користувачам. Авторизовані користувачі
            зможуть побачити ці замітки, якщо натиснуть на відповідну іконку у
            верхньому тулбарі. За замовчуванням замітки не відображаються. Не
            використовуйте круглі дужки для слів, які мають постійно
            відображатися на екрані.
          </p>
          <p className="manual-text">
            <span className="highlight">Редагувати пісню.</span> Для редагування
            пісні, відкрийте необхідну пісню й нажміть на іконку редагування у
            тулбарі зверху. У режимі редагування, ви можете змінти будь яку
            інформацю про пісню. Якщо ви оберете іншу тональність в режимі
            редагування, акорди зміняться автоматично. Якщо акорди не
            змінюються, спробуйте вибрати якусь іншу тональність, а потім знову
            ту, яка вам потрібна, і акорди зміняться. Якщо ви хочете виправити
            акорди, або вам не подобається, як вони змінилися автоматично,
            зробіть це вручну. Якщо ви невірно визначили тональність, то ви не
            можете просто вибрати іншу тональність в режимі редагування, тому що
            акорди в тексті будуть змінюватися відповідно. Щоб виправити
            тональність, скопіюйте текст пісні, очистіть текстовий редактор,
            змініть тональність, а потім вставте пісню назад as plain text. При
            зміні тональності в режимі редагування можуть додаватися зайві пусті
            рядки. Видаліть їх вручну.
          </p>
          <p className="manual-text">
            <span className="highlight">Видалити пісню.</span> Щоб видалити
            пісню, натисніть кнопку{" "}
            <span className="highlight">Видалити пісню</span> у правому
            сайдбарі.
          </p>
          <p className="manual-text">
            <span className="highlight">Завантажити медіа.</span> Для кожної
            пісні є можливість завантажити додаткові файли або посилання на
            медіа ресурси. Для цього натисніть{" "}
            <span className="highlight">Завантижати медія</span> у правому
            сайдбарі та слідуйте вказівкам. Файли будуть відображатися у правому
            сайдбарі під тими назвами, які ви введете для них у відповідному
            полі.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Режим повного екрану</h3>
          <p className="manual-text">
            У режимі повного екрану можна переглядати окремі пісні (іконка
            екрану у верхньому тулбарі), а також підбірки. Зверху є тулбар з
            іконками, якими можна змінювати формат відображення. Можна ховати і
            показувати акорди чи замітки. Можна керувати розімром шрифта. За
            замовчуванням всі пісні відоборажаються в одну колонку. Іконка з
            двома колонками дозволяє поділити пісню на дві колонки. В режимі
            повного екрану також можна змінювати тональність. Якщо ви відкрили в
            цьому режимі підбірку, то всі іконки працюють окремо для кожної
            пісні, окрім другу у PDF.
          </p>
          <p className="manual-text">
            <span className="highlight"> Друк у PDF</span>. Другува у PDF можна
            тільки з режиму повного екрану. Ця функція відкриває пісню у новому
            вікні у форматі PDF, де її можна роздрукувати або збереги на ваш
            девайс. Якщо вам не подобається як пісня виглядає у PDF, спробуйте
            змінити форматування у режимі повного керану - збільшити чи зменшити
            шрифт, змінити кількість колонок - і спробуйте знову.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Кабінет</h3>
          <p className="manual-text">
            Кожен зареєстрований користувач отримує власний кабінет для
            керування збірниками, підбірками, особистими даними. Для переходу у
            кабінет потрібного натиснути на іконку профілю наверху біля свого
            імені.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Підбірки</h3>
          <p className="manual-text">
            <span className="highlight">Підбірки</span> призначені для того, щоб
            вибирати певну кількість пісень для виконання й відкривати їх у
            режимі повного екрану. Можна створювати скільки завгодно підбірок і
            груп підбірок.
          </p>
          <p className="manual-text">
            Для того, щоб створювати підбірки, спочатку потрібно створити
            <span className="highlight"> групу.</span> Група може бути
            індивідувальною або тематичною, а може бути спільною. Будь-яку групу
            можна зробити спільною, якщо додати учасників. Учасники групи можуть
            створювати й редагувати підбірки в цій групі. У Кабінеті у влкадці{" "}
            <span className="highlight">Підбірки</span> натисніть{" "}
            <span className="highlight">Вибрати групу</span> і виберіть{" "}
            <span className="highlight">Створити групу</span>. Ви можете додати
            учасників до групи. Для цього знайдіть у пошуку учасника, натисніть
            іконку <span className="highlight">Перейти</span> у полі вводу -
            Ім&apos;я учасника з&apos;явиться внизу. Додайте стільки учасників,
            скільки потрібно. Якщо ви є учасником іншої групи, то ви можете
            відкрити цю групу з переліка груп і створювати в ній підбірки. У
            майбутньому користувачі плану{" "}
            <span className="highlight">Вільний</span> зможуть бути учасниками
            груп і створювати в них підбірки, але не зможуть створювати власні
            групи підбірок. Якщо ви будете користувачем плану{" "}
            <span className="highlight">Індивідуальний</span>, то ви зможете
            створити групу для власного користування, але не зможете додати до
            неї учасників.
          </p>
          <p className="manual-text">
            <span className="highlight">Підбірки.</span>Якщо ви створили групу,
            або вас додали учасником до іншої групи, ви можете створювати,
            редагувати й видаляти підбірки, змінювати порядок пісень у
            підбірках. У віконці створення підбірок виберіть збірник, а в полі
            вводу пісень, виберіть пісню й натисніть іконку переходу у полі
            вводу - пісня з&apos;явиться внизу. Натискайте стрілочки, щоб
            змінити порядок пісень.
          </p>
        </div>
        {/* <div className="section">
          <h3 className="section-title">Як припинити підписку</h3>
          <p className="manual-text">
            Якщо ви хочете припинити підписку, але у вас є збірник, в якому
            більше 15 пісень, то ви можете завантижити ці пісні у PDF форматі,
            щоб не втратити їх. Якщо ви не будете видаляти збірник, а просто
            припините підписку, то збірник залишиться у базі даних, але ви
            будете мати доступ тільки до перших 15 пісень. Якщо ви видалите свій
            збірник, всі пісні також будуть видалені. Підписка припиняється як
            тільки ви перестаєте вносити оплату. Так само легко її відновити -
            почати вносити оплату за своїм планом. Для того, щоб видалити свій
            акаунт у додатку повністю, зверніться у підтримку через телеграм бот
            (у футері додатка) або напишіть на електрону почту.
          </p>
        </div> */}
        <div className="section">
          <h3 className="section-title">Пропозиції</h3>
          <p className="manual-text">
            Якщо у вас є питання або пропозиції, ви можете звернутися у
            підтримку через телеграм бот (у футері додатка) або написати нам на
            електронну пошту (адреса у футері додатка).
          </p>
        </div>
        <h3 className="section-title">Приємного користування!</h3>
      </div>
    </div>
  );
};
export default Manual;
